<template>
  <div>
    <!--    <h3>Create Invoice</h3>-->
    <section>
      <div class="form-inline">
        <label for="startTime">Start time:</label>
        <VueCtkDateTimePicker
          v-model="startTime"
          :max-date="endTime"
          :no-label="false"
          :only-date="true"
          :auto-close="true"
          :no-value-to-custom-elem="true"
          format="YYYY-MM-DD"
          formatted="ll"
        >
          <input
            type="text"
            id="startTime"
            :value="startTime"
            placeholder="select date"
          />
        </VueCtkDateTimePicker>
      </div>
      <div class="form-inline">
        <label for="endTime">End time:</label>
        <div>
          <VueCtkDateTimePicker
            v-model="endTime"
            :min-date="startTime"
            :no-label="false"
            :only-date="true"
            :auto-close="true"
            :no-value-to-custom-elem="true"
            format="YYYY-MM-DD"
            formatted="ll"
          >
            <input
              type="text"
              id="endTime"
              :value="endTime"
              placeholder="select date"
            />
          </VueCtkDateTimePicker>
        </div>
      </div>
      <div class="form-inline flex-row">
        <label>Finalized:</label>
        <div>
          <model-select
            :options="finalizedOptions"
            v-model="editFinalized"
            placeholder="Finalized"
          ></model-select>
        </div>
      </div>
      <div class="form-inline flex-row">
        <!-- <button class="submit primary" @click="buttonClick">Create Invoice</button> -->
        <spinnerButton
          class="submit primary"
          :loading="submitLoading"
          @click.native="buttonClick"
          >Create Invoice</spinnerButton
        >
      </div>
    </section>
  </div>
</template>

<script>
import VueCtkDateTimePicker from "vue-ctk-date-time-picker";
import "vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css";
import moment from "moment";
import spinnerButton from "@/components/public/SpinnerButton";
import { ModelSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";

export default {
  props: ["submitLoading"],
  data() {
    return {
      startTime: null,
      endTime: null,
      editFinalized: false,
      finalizedOptions: [
        { text: "true", value: true },
        { text: "false", value: false },
      ],
    };
  },
  components: { VueCtkDateTimePicker, spinnerButton, ModelSelect },
  created: function () {
    this.initData();
  },
  methods: {
    initData: function () {
      this.startTime = moment()
        .subtract(1, "month")
        .startOf("month")
        .format("YYYY-MM-DD");
      this.endTime = moment()
        .subtract(1, "month")
        .endOf("month")
        .format("YYYY-MM-DD");
    },
    buttonClick: function () {
      if (!this.startTime || !this.endTime) {
        this.$toasted.global.toast_error({ message: "invalid time" });
        return;
      }
      const startTime = moment(this.startTime).startOf("day").valueOf() / 1000;
      const endTime = moment(this.endTime).endOf("day").valueOf() / 1000;
      const isFinalized = this.editFinalized;
      this.$emit("closePanel");
      this.$emit("buttonClick", { startTime, endTime, isFinalized });
    },
  },
};
</script>
